import module from 'module';
import _ from 'lodash';

const templateUrl = require('./teller-cash-overage.template.html');
module.component('tellerCashOverage', {
  templateUrl: templateUrl,
  controller: function (authentication, actionCommand, userCache, ledgerActionTemplateCache,
                        miscTransactionsService, commandRoleMapCache, commandAccessChecker) {
    const that = this;
    that.transaction = {};
    that.approvalUsers = [];

    const userSub = userCache.toObservable()
      .combineLatest(ledgerActionTemplateCache.toObservable(), commandAccessChecker.canApproveCommandObservable(),
          (users, templates, canApproveCommand) => {
        const template = _.find(templates, {type: 'TELLER_CASH_OVERAGE'});
        const branchId = authentication.context.branchId;
        that.approvalUsers = miscTransactionsService.filterApprovalUsers(branchId, template, users, canApproveCommand);
        return users;
      })
      .subscribe(users => {
      });

    that.cancelChanges = () => {
      actionCommand.cancelChanges();
    };

    that.save = () => {
      actionCommand.execute('TELLER_CASH_OVERAGE', that.transaction);
    };

    that.$onDestroy = () => {
      userSub.unsubscribe();
    }
  }
});
